import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LocalStorageService } from '@services/local-storage.service';
import { VersionsFacade } from '@facades/versions.facade';
import { VersionDialog } from '@pages/preferences/dialogs/version-dialog/version-dialog.component';
import { IVersion } from '@interfaces/version';
import { EUserProfileIds } from '@interfaces/user';
import { AuthFacade } from '@facades/auth.facade';
import { filter, switchMap, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VersionDialogService {
	private ref?: DynamicDialogRef;
	private isDialogOpen = false;

	constructor(
		private dialogService: DialogService,
		private versionsFacade: VersionsFacade,
		private authFacade: AuthFacade,
		private localStorageService: LocalStorageService
	) {}

	checkAndShowDialog(): void {
		this.authFacade.authState$
			.pipe(
				take(1),
				filter(({ user }) => !!user),
				filter(({ user }) =>
					[EUserProfileIds.APPLICATION_ADMIN, EUserProfileIds.SELLER].includes(
						user!.profileId
					)
				),
				switchMap(() =>
					this.versionsFacade
						.getLatestVersion({ solutionId: 'Portal' })
						.pipe(take(1))
				)
			)
			.subscribe({
				next: (data: any) => {
					const storedVersion = this.localStorageService.get('lastSeenUpdate');
					let lastSeenUpdate: { id: number } | null = null;

					lastSeenUpdate = storedVersion ? storedVersion : null;
					const showDialog = !lastSeenUpdate || lastSeenUpdate.id !== data.id;

					if (showDialog && !this.isDialogOpen) {
						this.openDialog(data);
						this.localStorageService.set('lastSeenUpdate', { id: data.id });
					}
				},
				error: e => {
					console.warn('Erro ao ler o localStorage:', e);
					localStorage.removeItem('lastSeenUpdate');
				},
			});
	}

	private openDialog(version: IVersion) {
		this.isDialogOpen = true;

		this.ref = this.dialogService.open(VersionDialog, {
			header: version.name,
			modal: true,
			styleClass: 'border-round overflow-hidden',
			width: '570px',
			closable: false,
			data: { version },
		});

		(this.ref as DynamicDialogRef).onClose.subscribe(() => {
			this.ref = undefined;
			this.isDialogOpen = false;
		});
	}
}
